import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Authentication} from '../common/_modals/auth.response';
import {AppEventService} from '../common/_services/event-broadcaster.service';
import {AuthenticationService} from '../common/_services/authentication.service';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {


    username: string;
    password: string;

    isRememberMe: boolean;
    isSubmitted = false;
    isLoggedIn = false;

    loginResponse: Authentication;

    constructor(private authService: AuthenticationService, private eventService: AppEventService) {
    }

    ngOnInit() {

    }


    login() {
        this.isSubmitted = true;

        this.authService.login(this.username, this.password)
            .subscribe(a => {
                localStorage.setItem('currentUser', JSON.stringify(a));
                this.eventService.broadcast('login.done', a);
            });

    }
}
